export default "__VITE_ASSET__Cj8bu8V7__"